import CostHTMLPreviewBaseColumnsStrategy from './CostHTMLPreviewBaseColumnsStrategy'

export default function CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy() {}

CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy.prototype = new CostHTMLPreviewBaseColumnsStrategy();

CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy.prototype.init = function({timeFormat, showAverageRates, showSubtotals, showOthers})
{
    CostHTMLPreviewBaseColumnsStrategy.prototype.init.call( this, timeFormat, false, showAverageRates );
    this.showSubtotals = showSubtotals;
    this.showOthers = showOthers
    return this;
};

CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy.prototype.addFirstHeaderRowDataCells = function( row )
{
    this.addOverallHeaderCells( row );
    this.addCell( row, SystemSettings.userGroupNamingSingular, "darkGreenHeaderCell userGroup", this.showOthers ? 2 : 3, 2 );
    if (this.showOthers) this.addCell( row, this.message("report.common.others"), "lightGreenHeaderCell userGroup", 1, 3 );
};

CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy.prototype.addSecondHeaderRowDataCells = function( row )
{
    // do nothing
};

CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy.prototype.addThirdHeaderRowDataCells = function( row )
{
    if( this.showSubtotals ) {
        this.addCell(row, this.message("report.subtotal"), "darkGreenHeaderCell")
    } else {
        this.addCell(row, this.message("report.user"), "lightGreenHeaderCell")
    }
    this.addCell( row, this.message( "report.user" ), "lightGreenHeaderCell" );
    if (!this.showOthers) this.addCell( row, this.message( "report.user" ), "lightGreenHeaderCell" );
};

CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy.prototype.addDataCells = function( row )
{
    this.addOverallDataCells( row );
    this.addMoneyValueCell( row );
    this.addMoneyValueCell( row );
    this.addMoneyValueCell( row );
};

CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy.prototype.getDataColumnsCount = function()
{
    return this.getOverallColumnsCount() + 3;
};

CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy.prototype.areThereTwoRowsInHeader = function ()
{
    return true;
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/cost/CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy.js